import request from "@/api";

export function listGoodsTemp(data) {
    return request({
        url: '/api/goods/getGoodsTempList',
        method: 'get',
        params: data
    })
}

export function getGoodsTempInfo(data) {
    return request({
        url: '/api/goods/getGoodsTempInfo',
        method: 'get',
        params: data
    })
}

export function saveGoodsTemp(data) {
    return request({
        url: '/api/goods/saveGoodsTemp',
        method: 'post',
        data: data
    })
}

export function deleteGoodsTemp(data) {
    return request({
        url: '/api/goods/deleteGoodsTemp',
        method: 'post',
        data: data
    })
}

export function updateGoodsTemp(data) {
    return request({
        url: '/api/goods/updateGoodsTemp',
        method: 'post',
        data: data
    })
}

export function exportGoodsTemp(data) {
    return request({
        url: '/api/goods/exportTemp',
        method: 'post',
        responseType: 'blob',
        data: data
    })
}

export function batchSaveGoodsTempRemoveRecover(data) {
    return request({
        url: '/api/goods/batchSaveGoodsTempRemoveRecover',
        method: 'post',
        data: data
    })
}